module.exports = __webpack_public_path__ + "img/swift-check-in-logo.7eefd8d0.svg";